// extracted by mini-css-extract-plugin
module.exports = {"Links":"Links_Links__8u1-w","Links_icon":"Links_Links_icon__2bdoO"};